/* ------------------------------------------------------------------------------
 *
 *  # Utility Functions Module
 *
 *  Utility and helper functions
 *
 * ---------------------------------------------------------------------------- */

import { isJQuery } from '../core/utils.js';

// Highlight all code blocks
export function highlightAll() {
    if (typeof Prism !== 'undefined') {
        // Resalta todos los bloques de código
        Prism.highlightAll();

        // Ejecuta manualmente el plugin toolbar
        if (Prism.plugins && Prism.plugins.toolbar) {
            // Busca todos los elementos pre > code que no tengan toolbar
            document.querySelectorAll('pre > code[class*="language-"]').forEach(function (codeElement) {
                const preElement = codeElement.parentNode;
                if (preElement && !preElement.parentNode.classList.contains('code-toolbar')) {
                    // Simula el evento que dispara el plugin toolbar
                    Prism.plugins.toolbar.hook({
                        element: codeElement,
                        language: Prism.util.getLanguage(codeElement),
                        grammar: null,
                        code: codeElement.textContent
                    });
                }
            });
        }
    }
}

// Wire search popup keyboard events
export function wireSearchEvents(dotnetRef, inputElement, popupElement) {
    inputElement.onkeydown = function (e) {
        if (!popupElement.classList.contains('sb-hide')) {
            switch (e.keyCode) {
                case 27:
                case 13:
                    if (e.keyCode === 13) {
                        var liElement = popupElement.querySelector('li.sf-search-hover');
                        if (liElement) {
                            liElement.click();
                        }
                    }
                    else {
                        this.value = "";
                    }
                    dotnetRef.invokeMethodAsync('HidePopup', true);
                    break;
                case 38:
                case 40:
                    var liElements = popupElement.querySelectorAll('li.sf-list-li');
                    if (!liElements.length) {
                        return;
                    }
                    var prevLi = popupElement.querySelector('li.sf-search-hover');
                    if (prevLi) {
                        var liElement = e.keyCode === 40 ? prevLi.nextElementSibling : prevLi.previousElementSibling;
                        if (liElement && liElement.classList.contains('sf-list-group-li')) {
                            liElement = e.keyCode === 40 ? liElement.nextElementSibling : liElement.previousElementSibling;
                        }
                        if (!liElement) {
                            liElement = e.keyCode === 40 ? liElements[0] : liElements[liElements.length - 1];
                        }
                        prevLi.classList.remove('sf-search-hover');
                        liElement.classList.add('sf-search-hover');
                    }
                    else if (liElements) {
                        var liElement = e.keyCode === 40 ? liElements[0] : liElements[liElements.length - 1];
                        liElement.classList.add('sf-search-hover');
                    }
                    dotnetRef.invokeMethodAsync('UpdateKeyboardInteraction');
                    break;
            }
        }
    };
}

// File operations
export function uploadFilesClick() {
    document.getElementById('UploadFiles').click();
}

export function loadFile(file) {
    let base64 = file.rawFile.replace("data:application/json;base64,", "");
    let json = atob(base64)
    return json;
}

export async function saveFile(filename, content, isBase64 = false) {
    let blob;
    
    // Determinar el MIME type según la extensión del archivo
    let mimeType = "application/octet-stream";
    if (filename) {
        const extension = filename.toLowerCase().split('.').pop();
        const mimeTypes = {
            'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'xls': 'application/vnd.ms-excel',
            'pdf': 'application/pdf',
            'csv': 'text/csv',
            'json': 'application/json',
            'xml': 'application/xml',
            'zip': 'application/zip',
            'txt': 'text/plain',
            'png': 'image/png',
            'jpg': 'image/jpeg',
            'jpeg': 'image/jpeg',
            'gif': 'image/gif',
            'svg': 'image/svg+xml'
        };
        mimeType = mimeTypes[extension] || mimeType;
    }
    
    if (isBase64) {
        // Convert Base64 string to ArrayBuffer
        const binaryString = window.atob(content);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        blob = new Blob([bytes.buffer], { type: mimeType });
    } else {
        // Assume content is an ArrayBuffer
        blob = new Blob([content], { type: mimeType });
    }

    if (window.navigator.msSaveBlob) {
        // For Edge browser
        window.navigator.msSaveBlob(blob, filename);
    } else {
        // For other browsers
        const url = URL.createObjectURL(blob);
        const anchorElement = document.createElement('a');
        anchorElement.href = url;
        anchorElement.download = filename ?? 'download';
        document.body.appendChild(anchorElement); // Needed for Firefox
        anchorElement.click();
        document.body.removeChild(anchorElement);
        URL.revokeObjectURL(url);
    }
}

// Input focus
export function inputFocus(inputElement) {
    inputElement.focus();
}

// UI helper functions
export function updateNavLinks(clickedElement, allActive, blockElement) {
    if (allActive) {
        $('.sidebar-material-group .nav-link').removeClass('active');
        $('.sidebar-material-group .nav-link').removeClass('disabled');
    } else {
        // Remove 'active' class from all NavLink elements
        $('.sidebar-material-group .nav-link').removeClass('active');

        $('#btnUpdateCancel').removeClass('d-none');
        // Add 'active' class to the clicked element
        $(clickedElement).addClass('active');
        if (blockElement) {
            // Disable all NavLink elements
            $('.sidebar-material-group .nav-link').addClass('disabled');
        }
    }
}

export function clearElement(id) {
    $(id).val(null);
}

export function showElement(id, show) {
    if (show)
        $(id).removeClass('d-none');
    else
        $(id).addClass('d-none');
}

export function showMenssage(tittle, message, icon, isHtml) {
    const validIcons = ["success", "error", "warning", "info", "question"];
    if (!validIcons.includes(icon)) {
        icon = "success";
    }

    if (isHtml) {
        window.swalInit.fire({
            title: tittle,
            html: message,
            icon: icon,
        });
    } else {
        window.swalInit.fire({
            title: tittle,
            text: message,
            icon: icon,
        });
    }
}

export function managementSelect(id, data, placeholder, valueInit, disabled) {
    let $eventSelect = $(id).select2({
        placeholder: placeholder,
        data: data
    });

    if (valueInit != null) {
        $eventSelect.val(valueInit).trigger('change');
    } else {
        $eventSelect.val(null).trigger('change');
    }

    if (disabled) {
        $eventSelect.prop('disabled', true);
    } else {
        $eventSelect.prop('disabled', false);
    }
}

export function readOnly(id, isRead) {
    $(id).attr('disabled', isRead);
}

// Spinner functions
export function toggleSpinner(show) {
    setTimeout(function () {
        const spinner = document.getElementById('loading-spinner');
        const content = document.querySelector('.page-content');
        if (spinner && content) {
            if (show) {
                spinner.classList.remove('hidden');
                content.style.visibility = 'hidden';
            } else {
                spinner.classList.add('hidden');
                content.style.visibility = 'visible';
            }
        }
    }, 200);
}

export function toggleAjax(show, progressText = '') {
    setTimeout(function () {
        const spinner = document.querySelector('.loader-overlay');
        const progressElement = document.getElementById('loader-progress-text');
        
        if (spinner) {
            if (show) {
                spinner.classList.remove('d-none');
                
                // Update progress text if element exists and text is provided
                if (progressElement && progressText) {
                    progressElement.textContent = progressText;
                }
            } else {
                spinner.classList.add('d-none');
                
                // Clear progress text when hiding
                if (progressElement) {
                    progressElement.textContent = '';
                }
            }
        }
    }, 200);
}

export function updateProgressText(progressText) {
    const progressElement = document.getElementById('loader-progress-text');
    if (progressElement) {
        progressElement.textContent = progressText;
    }
}
